import { Component, OnInit, Input, Output, EventEmitter, OnChanges } from '@angular/core';
import { isNullOrUndefined, isNull } from 'util';
import { Plato } from 'src/app/core';

@Component({
  selector: 'app-dialog',
  templateUrl: './dialog.component.html',
  styleUrls: ['./dialog.component.scss']
})
export class DialogComponent implements OnInit, OnChanges {

  @Input() titulo: string;
  @Input() showComboUsers: boolean;
  @Input() users: any;
  @Input() showComboPlatos: boolean;
  @Input() platos: any;
  @Input() showComments: boolean;
  @Input() showSwitch: boolean;
  @Input() datos: any = { user: '', plato: '', comentario: '', id: '' };
  @Input() displayDialog: boolean;
  @Input() header: string;
  @Input() quienLlama: string;
  @Output() emitAction: EventEmitter<any> = new EventEmitter<any>();
  datosSalida = {
    user: '',
    plato: '',
    comentario: '',
    platoDia: '',
    id: null
  };
  userSelected;
  platoSelected;
  comentario;
  idPedido;
  platoDia=false;
  platoId;
  platoHabilitado;
  constructor() { }

  ngOnInit() {
    this.platoDia = false;
  }
  ngOnChanges(event) {
    //REVISAR
    if (this.quienLlama != 'platoCompo') {
      if (!isNullOrUndefined(this.datos)) {
        if (!isNullOrUndefined(this.datos.user)) {
          if (this.quienLlama == 'newPedido'){
            if (!isNullOrUndefined(this.users && this.platos)){
              this.userSelected = this.users[0];
              this.platoSelected = this.platos[0];
              this.comentario = '';
            }
          }else{
            this.userSelected = this.datos.user;
            this.platoSelected = this.datos.plato;
            this.comentario = this.datos.comentario;
            this.idPedido = this.datos.id;
          }
        }
      }
    } else {
      if (!isNullOrUndefined(this.datos)) {
        if (this.datos instanceof (Plato)){
          let plato: Plato = this.datos;
          this.comentario = plato.getDescripcion();
          this.platoDia = plato.getPlatoDelDia();
          this.platoId = plato.getId();
          this.platoHabilitado = plato.getHabilitado();
        }
      }
    }

  }

  save() {
    this.displayDialog = false;
    if (this.quienLlama != "platoCompo"){
      let req;
      this.datosSalida.user = this.userSelected;
      this.datosSalida.plato = this.platoSelected;
      this.datosSalida.comentario = this.comentario;
      this.datosSalida.id = this.idPedido;
      if (!this.showComboUsers) {
        req = { accion: 'updatePedido', data: this.datosSalida }
      } else {
        req = { accion: 'nuevoPedido', data: this.datosSalida }
      }
      this.emitAction.emit(req);
    }else{
      let datos = {
        id: this.platoId,
        platoDia: this.platoDia,
        descripcion: this.comentario,
        habilitado: true
      }
      if (isNullOrUndefined(this.platoId)){
        this.emitAction.emit({accion: 'newPlato', data: datos});
        this.limpiarInfo();
      }else{
        this.emitAction.emit({accion: 'updatePlato', data: datos});
        this.limpiarInfo();
      }
    }
    this.displayDialog = false;
  }
  cancel() {
    this.displayDialog = false;
    this.emitAction.emit({ accion: 'cancel', data: null });
    this.limpiarInfo();
  }
  limpiarInfo(){
    this.platoDia = null;
    this.platoHabilitado = null;
    this.platoId = null;
    this.comentario = null;
  }

}
